export default __webpack_public_path__ + "static/media/logoBlack.66e09d35.svg";